import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, KeyRound } from "lucide-react";

export default function Resume() {
    const navigate = useNavigate();
    const [token, setToken] = useState("");

    const submit = (e) => {
        e.preventDefault();
        const t = token.trim();
        if (!t) {
            toast.error("Please paste your resume token.");
            return;
        }
        navigate(`/intake?token=${encodeURIComponent(t)}`);
    };

    return (
        <div className="intake-shell flex flex-col" data-testid="resume-page">
            <header className="px-6 md:px-12 py-6">
                <button
                    onClick={() => navigate("/")}
                    className="text-sm text-white/60 hover:text-white inline-flex items-center gap-2"
                    data-testid="resume-back-btn"
                >
                    <ArrowLeft size={16} />
                    Back
                </button>
            </header>
            <main className="flex-1 flex items-center justify-center px-6">
                <div className="intake-card w-full max-w-lg p-8 md:p-10 animate-fade-up">
                    <div className="w-12 h-12 rounded-xl bg-[#D4AF37]/10 border border-[#D4AF37]/30 flex items-center justify-center mb-6">
                        <KeyRound className="text-[#D4AF37]" size={20} />
                    </div>
                    <h1 className="font-display text-3xl sm:text-4xl text-white">Resume application</h1>
                    <p className="mt-3 text-white/55 text-sm">
                        Paste the resume token you saved earlier to continue exactly where you left off.
                    </p>
                    <form onSubmit={submit} className="mt-8 space-y-5">
                        <div>
                            <label className="field-label block mb-2">Resume token</label>
                            <input
                                type="text"
                                value={token}
                                onChange={(e) => setToken(e.target.value)}
                                placeholder="e.g. xWqe2-AnPpoZ_…"
                                className="glow-input w-full px-4 py-3 rounded-xl"
                                data-testid="resume-token-input"
                                autoFocus
                            />
                        </div>
                        <button type="submit" className="btn-gold w-full py-3" data-testid="resume-submit-btn">
                            Continue
                        </button>
                    </form>
                </div>
            </main>
        </div>
    );
}
